import { colors } from '@/theme/colors';

type CarActionsMusicIconProps = {
  size?: { width: number; height: number };
  fill?: string;
};

export default function CarActionsMusicIcon({
  size = { width: 24, height: 24 },
  fill = colors.neutral10,
}: CarActionsMusicIconProps) {
  return (
    <svg
      width={`${size.width}px`}
      height={`${size.height}px`}
      viewBox={`0 0 ${size.width} ${size.height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4585_263071)">
        <path
          d="M16.083 21C16.083 21.2967 15.995 21.5867 15.8302 21.8334C15.6654 22.08 15.4311 22.2723 15.157 22.3858C14.8829 22.4993 14.5813 22.5291 14.2904 22.4712C13.9994 22.4133 13.7321 22.2704 13.5223 22.0607C13.3126 21.8509 13.1697 21.5836 13.1118 21.2926C13.054 21.0017 13.0837 20.7001 13.1972 20.426C13.3107 20.1519 13.503 19.9176 13.7497 19.7528C13.9963 19.588 14.2863 19.5 14.583 19.5H16.083V21Z"
          stroke={fill}
          strokeOpacity="1"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M23.583 18C23.583 18.2967 23.495 18.5867 23.3302 18.8334C23.1654 19.08 22.9311 19.2723 22.657 19.3858C22.3829 19.4993 22.0813 19.5291 21.7904 19.4712C21.4994 19.4133 21.2321 19.2704 21.0223 19.0607C20.8126 18.8509 20.6697 18.5836 20.6118 18.2926C20.554 18.0017 20.5837 17.7001 20.6972 17.426C20.8107 17.1519 21.003 16.9176 21.2497 16.7528C21.4963 16.588 21.7863 16.5 22.083 16.5H23.583V18Z"
          stroke={fill}
          strokeOpacity="1"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.083 19.4998V14.5148C16.0832 14.2151 16.1731 13.9223 16.3411 13.6742C16.5092 13.4261 16.7478 13.2341 17.026 13.1228L22.554 10.9108C22.6681 10.8653 22.7917 10.8485 22.9138 10.8619C23.0359 10.8753 23.1529 10.9184 23.2544 10.9875C23.356 11.0566 23.4391 11.1495 23.4963 11.2582C23.5536 11.3669 23.5834 11.4879 23.583 11.6108V16.4998"
          stroke={fill}
          strokeOpacity="1"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.28418 6.858L5.03318 2.96C5.19401 2.5307 5.4822 2.1608 5.85913 1.89986C6.23606 1.63892 6.68374 1.4994 7.14218 1.5H16.0242C16.4826 1.49969 16.9301 1.63931 17.307 1.90022C17.6839 2.16112 17.9721 2.53086 18.1332 2.96L19.8832 6.86"
          stroke={fill}
          strokeOpacity="1"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.83301 13.2998V14.9998C1.83301 15.3976 1.99104 15.7792 2.27235 16.0605C2.55365 16.3418 2.93518 16.4998 3.33301 16.4998C3.73083 16.4998 4.11236 16.3418 4.39367 16.0605C4.67497 15.7792 4.83301 15.3976 4.83301 14.9998V13.4998"
          stroke={fill}
          strokeOpacity="1"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.45801 9.75C4.35855 9.75 4.26317 9.78951 4.19284 9.85983C4.12252 9.93016 4.08301 10.0255 4.08301 10.125"
          stroke={fill}
          strokeOpacity="1"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.83301 10.125C4.83301 10.0255 4.7935 9.93016 4.72317 9.85983C4.65285 9.78951 4.55746 9.75 4.45801 9.75"
          stroke={fill}
          strokeOpacity="1"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.45801 10.5C4.55746 10.5 4.65285 10.4605 4.72317 10.3902C4.7935 10.3198 4.83301 10.2245 4.83301 10.125"
          stroke={fill}
          strokeOpacity="1"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.08301 10.125C4.08301 10.2245 4.12252 10.3198 4.19284 10.3902C4.26317 10.4605 4.35855 10.5 4.45801 10.5"
          stroke={fill}
          strokeOpacity="1"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21.6811 8.25C21.4176 7.79366 21.0386 7.41477 20.5821 7.15144C20.1257 6.88812 19.608 6.74966 19.0811 6.75H4.08105C3.28541 6.75 2.52234 7.06607 1.95973 7.62868C1.39713 8.19129 1.08105 8.95435 1.08105 9.75V12C1.08105 12.3978 1.23909 12.7794 1.52039 13.0607C1.8017 13.342 2.18323 13.5 2.58105 13.5H13.0811"
          stroke={fill}
          strokeOpacity="1"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4585_263071">
          <rect
            width="24"
            height="24"
            fill="white"
            fillOpacity="1"
            transform="translate(0.333008)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
